import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs md:text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-700 transition-colors whitespace-nowrap">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-x-2">
            <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-700 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}